module.exports = function() {
  return new Worker(__webpack_public_path__ + "61de5676dcd405dcd137.worker.js");
};